<template>
  <div class="middle-box text-center loginscreen  animated fadeInDown">

    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>

    <form class="m-t" role="form">

      <div class="form-group">
        <input type="email" name="email" class="form-control" placeholder="Email"
        v-model="credentials.email" v-validate="'required|email'" :class="{invalid: errors.has('email')}">
        <span class="error">{{ errors.first('email') }}</span>
      </div>

      <div class="form-group">
        <input :type="fieldType" class="form-control input-btn" name="password" placeholder="Senha"
        v-model="credentials.password" v-validate="'required|min:4'" :class="{invalid: errors.has('password')}">
        <span class="error">{{ errors.first('password') }}</span>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox" @click="passVisibility">
        <label class="form-check-label"> Exibir senha</label>
      </div>

      <br />

      <button class="btn btn-success btn-block" @click.prevent="login(credentials)">Entrar</button>

      <div class="text-center">
        <button type="button" class="btn btn-link">
          <router-link to="/forgot-password"><small>Esqueci a senha</small></router-link>
        </button>
      </div>

    </form>

    <p class="m-t"> <small>SS PARISI todos direitos reservados &copy; {{ year }}</small> </p>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { httpService } from '../providers/http-service'
import { toast } from '../mixins/toast'
import { errorMessage } from '../mixins/error-message'
import Spinner from './layout/Spinner'

export default {
  mixins: [ toast, errorMessage ],
  components: { Spinner },
  data () {
    return {
      credentials: { email: '', password: '' },
      showSpinner: false,
      fieldType: 'password',
      year: new Date().getFullYear()

    }
  },
  methods: {
    ...mapActions(['setLoggedUser', 'setPermissions']),

    passVisibility () {
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password'
    },

    redirectToHome () {
      return this.$router.push({ path: '/home' })
    },

    redirectToRequestApp (link, token) {
      const url = new URL(link)
      url.searchParams.append('access_token', token)

      window.location.replace(url)
    },

    redirect () {
      const token = localStorage.getItem('token')
      const redirectLink = this.$route.query.continue

      if (!token) {
        return
      }

      if (redirectLink) {
        return this.redirectToRequestApp(redirectLink, token)
      }

      return this.redirectToHome()
    },

    displayParamsErrorMessage () {
      const errorMessage = this.$route.params.errorMessage

      if (errorMessage) {
        this.show_toast('info', '', errorMessage)
      }
    },

    login (credentials) {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.showSpinner = true
          httpService.login({ email: credentials.email, password: credentials.password }).then((res) => {
            let user = res.data
            localStorage.setItem('token', user.token)
            this.setLoggedUser({ id: user.public_key, name: user.name, email: user.email, img: user.image, token: user.token, companies: user.companies })
            this.setPermissions(user.companies)
            this.showSpinner = false
            this.redirect()
          }).catch(err => this.showErrorMessage({ err: err }))
        } else {
          this.showSpinner = false
          this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
          this.$validator.validateAll()
        }
      })
    }
  },

  created () {
    this.redirect()
  },

  mounted () {
    this.redirect()
    this.displayParamsErrorMessage()
  }
}
</script>

<style>
  .image-logo { height: 200px; position: relative; }

  .image-logo img {
    display: block;
    max-width: 100%;
    position: absolute;
    bottom:0;
    left:50%;
    transform:translateX(-50%);
    margin: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue